import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";

import axios from "axios";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";

import moment from "moment";
import TablaTrasladoOrigen from "./tablaTotalTrasladar";
import TablaDestino from "./TablaDestinoTraslado";
import CatalogoOrganismot from "../../catalogos/catalogoOrganismos";

import { SuccessButton, DangerButton, PrimaryButton } from "../../ui/buttons/Button";
import { Input, SearchInput, Textarea } from "../../ui/inputs/Input";

export const TrasladosdeFondos = (props) => {
  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  // const idusuario = JSON.parse(localStorage.getItem('idusuario'));
  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));
  const espiritu = JSON.parse(localStorage.getItem('espiritu'));
  const anioefis = JSON.parse(localStorage.getItem("efiscalanio"));

  const [activate, setActivate] = useState(false);
  const [deshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [datospre, setDatospre] = useState([]);
  const [datospred, setDatospred] = useState([]);
  const [valida, setValida] = useState(0);
  const [validat, setValidat] = useState(0);
  const [val, setVal] = useState(0.0);
  const [mostrar3, setMostrar3] = useState(false);
  const [val2, setVal2] = useState(0.0);
  const [v, setV] = useState(0);
  const [vt, setVt] = useState(0);
  const [idpc, setIdpc] = useState([]);
  const [validatab, setValidatab] = useState([]);
  const [validatabd, setValidatabd] = useState([]);
  const [cat, setCat] = useState(0);
  const [pucc, setPucc] = useState(0);
  const [data, setData] = useState([]);
  const [datad, setDatad] = useState([]);
  const [body, setBody] = useState(null);
  const [codigo, setCodigo] = useState(0);
  const [numtrasla, setNumTrasla] = useState(0);
  const [chek, setChek] = useState(0);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [values, setValues] = useState({
    idcuenta: "",
    auxiliar: "",
    descripcionaux: "",
    idcategoriaprogramatica: "",
    idpuc: "",
    puc: "",
    categoria: "",
    disponibilidad: 0.0,
    montoinicial: 0.0,
    tipopartida: "",
  });

  const txtIdTransferencia = useRef();
  const txtFecha = useRef();
  const txtFechaAprobacion = useRef();
  const txtFechaReverso = useRef();
  const txtObservacion = useRef();
  const txtNp = useRef();
  const txtIdor = useRef();
  const txtNombreOr = useRef();
  const txtNTraslado = useRef();

  const onChange = (event) => {
    if (
      event.target.name === "descriaux" ||
      event.target.name === "ubicacion" ||
      event.target.name === "observacion"
    ) {
      event.target.value = event.target.value.toUpperCase();
    }
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtFecha.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Fecha",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if (new Date(txtFecha.current.value).getFullYear() !== anioefis) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El año no debe ser diferente al año del Ejercicio Fiscal actual",
        icono: "informacion",
      });
      sigue = false;
      txtFecha.current.focus();
    } else if (txtFechaAprobacion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Fecha de Aprobación",
        icono: "informacion",
      });
      sigue = false;
      txtFechaAprobacion.current.focus();
    } else if (new Date(txtFechaAprobacion.current.value).getFullYear() !== anioefis) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El año no debe ser diferente al año del Ejercicio Fiscal actual",
        icono: "informacion",
      });
      sigue = false;
      txtFechaAprobacion.current.focus();
    } else if ((operacion === 2 && txtFechaReverso.current.value.trim() === "") || (operacion === 3 && props.presu.fechareverso > 0 && txtFechaReverso.current.value.trim() === "")) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Fecha de Aprobación",
        icono: "informacion",
      });
      sigue = false;
      txtFechaReverso.current.focus();
    } else if ((operacion === 2 && new Date(txtFechaReverso.current.value).getFullYear() !== anioefis) || (operacion === 3 && props.presu.fechareverso > 0 && new Date(txtFechaReverso.current.value).getFullYear() !== anioefis)) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El año no debe ser diferente al año del Ejercicio Fiscal actual",
        icono: "informacion",
      });
      sigue = false;
      txtFechaReverso.current.focus();
    } else if (txtIdor.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar el Organismo",
        icono: "informacion",
      });
      sigue = false;
      txtIdor.current.focus();
    } else if (valida !== 1) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Cuenta Presupuestaria de Origen",
        icono: "informacion",
      });
      sigue = false;
    } else if (validat !== 1) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Debe Seleccionar la Cuenta Presupuestaria a Trasladar",
        icono: "informacion",
      });
      sigue = false;
    } else if (txtObservacion.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "Describa la Observación",
        icono: "informacion",
      });
      sigue = false;
      txtObservacion.current.focus();
    } else if (val < val2) {
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Monto Destino no puede ser Menor al Monto de Origen",
        icono: "informacion",
      });
      sigue = false;
    } else if (val > val2) { //revisar porq paso esto en el caso de edicion de fecha de reverso, se cambio el valor del monto destino por el monto origen y no se actualizo el valor del monto origen, entonces al validar el monto destino con el monto origen daba que el monto destino era mayor al monto origen, revisar esto para que no vuelva a pasar
      setMensaje({
        mostrar: true,
        titulo: "Notificación",
        texto: "El Monto Destino no puede ser Mayor al Monto de Origen",
        icono: "informacion",
      });
      sigue = false;
    } else if (sigue) {
      let datos = [];
      let datost = [];

      if (operacion === 1) {
        for (let e = 0; e < data.length; e++) {
          datos.push({
            idcuenta: data[e].idcuenta,
            auxiliar: data[e].auxiliar,
            idefiscal: idefiscal,
            monto: data[e].monto,
            tipomov: 2,
            fechamov: txtFecha.current.value,
            fechaapro: txtFechaAprobacion.current.value,
            observ: txtObservacion.current.value,
            idcat: data[e].idcat,
            idpuc: data[e].idpuc,
            idtrasn: 0,
            idorg: txtIdor.current.value,
            idmov: data[e].idmovimiento,
          });
        }

        for (let i = 0; i < datad.length; i++) {
          datost.push({
            idcuenta: datad[i].idcuenta,
            auxiliar: datad[i].auxiliar,
            idefiscal: idefiscal,
            monto: datad[i].monto,
            tipomov: 3,
            fechamov: txtFecha.current.value,
            fechaapro: txtFechaAprobacion.current.value,
            observ: txtObservacion.current.value,
            idcat: datad[i].idcat,
            idpuc: datad[i].idpuc,
            idtrasn: 0,
            idorg: txtIdor.current.value,
            idmov: datad[i].idmovimiento,
          });
        }
      } else if (operacion === 2 || operacion === 3 || operacion === 5) {
        for (let e = 0; e < datospre.length; e++) {
          datos.push({
            idcuenta: datospre[e].idcuenta,
            auxiliar: datospre[e].auxiliar,
            idefiscal: idefiscal,
            monto: datospre[e].monto,
            tipomov: datospre[e].tipo,
            fechamov: txtFecha.current.value,
            fechaapro: txtFechaAprobacion.current.value,
            observ: txtObservacion.current.value,
            idcat: datospre[e].idcategoriaprogramatica,
            idpuc: datospre[e].idpuc,
            idtrasn: datospre[e].idtransferencia,
            idorg: txtIdor.current.value,
            idmov: datospre[e].idmovimiento,
          });
        }

        for (let i = 0; i < datospred.length; i++) {
          datost.push({
            idcuenta: datospred[i].idcuenta,
            auxiliar: datospred[i].auxiliar,
            idefiscal: idefiscal,
            monto: datospred[i].monto,
            tipomov: datospred[i].tipo,
            fechamov: txtFecha.current.value,
            fechaapro: txtFechaAprobacion.current.value,
            observ: txtObservacion.current.value,
            idcat: datospred[i].idcategoriaprogramatica,
            idpuc: datospred[i].idpuc,
            idtrasn: datospred[i].idtransferencia,
            idorg: txtIdor.current.value,
            idmov: datospred[i].idmovimiento,
          });
        }
      }

      setBody({
        operacion: operacion,
        movimientos: datos,
        movimientost: datost,
        idf: idefiscal,
        fechr:
          operacion === 2 || (operacion === 3 && props.presu.fechareverso !== null)
            ? moment.utc(txtFechaReverso.current.value).format("DD-MM-YYYY")
            : null,
      });

      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos?.";
      } else if (operacion === 2) {
        msg = "Esta Seguro de Reversar este Traslado?.";
      } else if (operacion === 3) {
        if (props.presu.fechareverso === null) {
          msg = "Esta Seguro de Editar Fecha de este Traslado?.";
        } else {
          msg = "Esta Seguro de Editar Fecha de Reverso de este Traslado?.";
        }

      } else if (operacion === 5) {
        msg = "Esta Seguro de Eliminar este Traslado?.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const Actualizar = () => {
    let endpoint = `${op.conexion}/api/presupuesto/creartraslados`;
    setActivate(true);
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Traslado Registrado Correctamente",
              icono: "exito",
            });
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Traslado Reversado Correctamente",
              icono: "exito",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Fecha de Reverso Actaualizada Correctamente",
              icono: "exito",
            });
          } else if (operacion === 5) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Registro Eliminado Correctamente",
              icono: "exito",
            });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const blanquear = () => {
    setValues({
      idcuenta: "",
      auxiliar: "",
      descripcionaux: "",
      idcategoriaprogramatica: "",
      idpuc: "",
      puc: "",
      categoria: "",
      disponibilidad: 0.0,
      montoinicial: 0.0,
      tipopartida: "",
    });
    setDatospre([]);
    setDatospred([]);
    setActivate(false);
    setChek(0);
    setValida(0);
    setVal(0.0);
    setVal2(0.0);
    setCat(0);
    setPucc(0);
    setData([]);
    setIdpc([]);
    setBody(null);
    setCodigo(0);
    setValidat(0);
  };

  const handleCloseSi = () => {
    if (operacion === 1) {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      Actualizar();
    } else if (operacion === 2) {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      Actualizar();
    } else if (operacion === 3) {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      Actualizar();
    } else if (operacion === 5) {
      setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
      Actualizar();
    }
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideRenderizar();
    props.onHideCancelar();
    blanquear();
  };

  const BaseDatos = (data) => {
    let ids = [];
    let total = val2;
    if (operacion === 1) {
      if (data.length > 0) {
        setValida(1);
      } else {
        setValida(0);
      }
      total = 0.0;
      for (let i = 0; i < data.length; i++) {
        total = parseFloat(total) + parseFloat(data[i].monto);
        ids.push({
          id: data[i].idcuenta,
        });
      }
      total = Math.round(total * 100) / 100;
      setVal2(total);
      if (data.length > 0) {
        setVt(1);
      } else if (operacion !== 1) {
        setVt(0);
      } else {
        setVt(0);
      }
    }
    setValidatab(ids);
    setData(data);
    if (val > total) {
      setDatad([]);
      setDatospred([]);
    }
  };

  const BaseDatosd = (data) => {
    let ids = [];
    if (operacion === 1) {
      if (data.length > 0) {
        setValidat(1);
      } else {
        setValidat(0);
      }
      let total = 0.0;
      for (let i = 0; i < data.length; i++) {
        total = parseFloat(total) + parseFloat(data[i].monto);
        ids.push({
          id: data[i].idcuenta,
        });
      }
      total = Math.round(total * 100) / 100;
      setVal(total);
    }
    setDatad(data);
    setValidatabd(ids);
  };

  const SeleccionarSequencia = () => {
    let endpoint = `${op.conexion}/api/presupuesto/sequenciaaumentodisminu`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setNumTrasla(response.data.numtrasla);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const SeleccionarCodigo = () => {
    let endpoint = `${op.conexion}/api/presupuesto/ultimocodigoaumentodisminucion?idefiscal=${idefiscal}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          let codigo = response.data.codigo;
          let count = codigo + 1;
          setCodigo(count);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const catalogoOrganismo = (e) => {
    e.preventDefault();
    setMostrar3(true);
  };

  const handleCancelara = () => {
    setMostrar3(false);
  };

  const handleAceptaOr = (id, razon, direccion, rif, dencomer, tipo) => {
    setMostrar3(false);

    txtNombreOr.current.value = razon.trim();
    txtIdor.current.value = id;

    if (id > 0) {
      setV(1);
    }
  };

  const imprimirTraslados = () => {

    var reporte = "Pres_SE_TrasladoInd";
    if (espiritu === 15) {
      reporte = "Pres_SE_TrasladoIndGuanare";
    }

    var sql = "";

    sql =
      "TRAS.idtransferencia = " + txtIdTransferencia.current.value;
    var condicion = "";

    condicion = sql;
    window.open(
      op.reportes +
      "/contabilidadpresupuestaria?" +
      "reporte=" +
      reporte +
      "&CONDICION=" +
      condicion +
      "&idefiscal=" +
      idefiscal,
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        SeleccionarSequencia();
        SeleccionarCodigo();
        if (props.operacion !== 1) {
          setValues(props.presu);
          setDatospre(props.movi);
          setDatospred(props.movid);
          txtIdTransferencia.current.value = props.presu.idtransferencia;
          txtIdor.current.value = props.org.idproveedor;
          txtNombreOr.current.value = props.org.razonsocial.trim();
          txtNTraslado.current.value = "000" + props.presu.codigo;

          if (props.movi.length > 0 && props.movid.length > 0) {
            setValida(1);
            setValidat(1);
          }
        } else {
          txtIdTransferencia.current.value = "";
          txtObservacion.current.value = "";
          txtFecha.current.value = moment.utc(fechaSistema).format("YYYY-MM-DD");
          txtFechaAprobacion.current.value =
            moment.utc(fechaSistema).format("YYYY-MM-DD");
        }
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>
            {operacion === 1
              ? props.titulo
              : operacion === 2
                ? props.titulo
                : operacion === 3
                  ? props.titulo
                  : props.titulo}
          </h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Dimmer active={activate} inverted></Dimmer>
        <div>
          <input type="hidden" ref={txtNp} />

          <fieldset className="col-12 m-0 p-2 d-flex flex-wrap gap-2 border-azul rounded">
            <legend className="float-none m-0 w-auto">Datos</legend>
            {props.presu && props.presu.reversado > 0 && operacion !== 1 && (
              <div className="col-12 m-0 p-0 mb-2">
                <div className="input-group input-group-sm m-0 w-100">
                  <font color="red" size="1">
                    <h1 align="center">
                      <i>¡ El Traslado está Reversado !</i>
                    </h1>
                  </font>
                </div>
              </div>
            )}
            <div className="col-2 m-0 p-0">
              <Input
                label="ID:"
                type="text"
                disabled
                id="inputId"
                ref={txtIdTransferencia}
              />
            </div>
            <div className="col-2 m-0 p-0">
              <Input
                label="Fecha:"
                type="date"
                disabled={
                  operacion === 1 || (operacion === 3 && props.presu && props.presu.reversado === 0)
                    ? false
                    : true
                }
                defaultValue={
                  props.presu && props.presu.fechamov !== ""
                    ? moment.utc(props.presu.fechamov).format("YYYY-MM-DD")
                    : moment.utc(fechaSistema).format("YYYY-MM-DD")
                }
                id="inputDireccion"
                ref={txtFecha}
              />
            </div>
            <div className="col-3 m-0 p-0">
              <Input
                label="Fecha de Aprobación:"
                type="date"
                disabled={
                  operacion === 1 || (operacion === 3 && props.presu && props.presu.reversado === 0)
                    ? false
                    : true
                }
                defaultValue={
                  props.presu && props.presu.fechaapro !== ""
                    ? moment.utc(props.presu.fechaapro).format("YYYY-MM-DD")
                    : moment.utc(fechaSistema).format("YYYY-MM-DD")
                }
                id="inputDireccion"
                ref={txtFechaAprobacion}
              />
            </div>
            {(operacion === 4 && props.presu.fechareverso !== null) ||
              (operacion === 5 && props.presu.fechareverso !== null) ? (
              <div className="col-3 m-0 p-0">
                <Input
                  label="Fecha de Reverso:"
                  type="date"
                  disabled
                  defaultValue={
                    props.presu && props.presu.fechareverso !== null
                      ? moment.utc(props.presu.fechareverso).format("YYYY-MM-DD")
                      : moment.utc(fechaSistema).format("YYYY-MM-DD")
                  }
                  id="inputDireccion"
                  ref={txtFechaReverso}
                />
              </div>
            ) : operacion === 2 || (operacion === 3 && props.presu.fechareverso !== null) ? (
              <div className="col-3 m-0 p-0">
                <Input
                  label="Fecha de Reverso:"
                  type="date"

                  defaultValue={
                    props.presu && props.presu.fechareverso !== null
                      ? moment.utc(props.presu.fechareverso).format("YYYY-MM-DD")
                      : moment.utc(fechaSistema).format("YYYY-MM-DD")
                  }
                  id="inputDireccion"
                  ref={txtFechaReverso}
                />
              </div>
            ) : (
              ""
            )}
            <div className="col-2 m-0 ml-auto p-0">
              <Input
                label="Traslado N°:"
                disabled
                id="inputDireccion"
                ref={txtNTraslado}
              />
            </div>

            <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
              <legend className="float-none m-0 w-auto">Organismo</legend>

              <div className="col-2 m-0 p-0">
                <SearchInput
                  label="Código:"
                  disabled
                  id="inputDireccion"
                  disabledButton={
                    operacion === 4 || operacion === 5 || operacion === 2
                      ? true
                      : deshabilitado
                  }
                  onClickButton={catalogoOrganismo}
                  ref={txtIdor}
                />
              </div>
              <div className="col-10 m-0 p-0 pl-2">
                <Input
                  label="Nombre:"
                  disabled={true}
                  id="inputDireccion"
                  ref={txtNombreOr}
                />
              </div>
            </fieldset>
          </fieldset>
          <fieldset className="row border-azul rounded mx-auto">
            <legend className="float-none m-0 w-auto">Cuenta(s) Origen</legend>

            <div className="col-md-12 px-0">
              <TablaTrasladoOrigen
                data={BaseDatos}
                validatabla={validatabd}
                datarecords={datospre}
                dataorigen={data}
                datadestino={datad}
                operacion={operacion}
                validaboton={v}
              />
            </div>
          </fieldset>
          <fieldset className="row border-azul rounded mx-auto">
            <legend className="float-none m-0 w-auto">
              Cuenta(s) Destinos
            </legend>

            <div className="col-md-12 px-0">
              <TablaDestino
                data={BaseDatosd}
                validatabla={validatab}
                monto={parseFloat(val2) - parseFloat(val)}
                datarecords={datospred}
                dataorigen={data}
                datadestino={datad}
                operacion={operacion}
                validabotont={vt}
              />
            </div>
          </fieldset>
          <fieldset className="col-12 m-0 mt-2 p-2 border-azul rounded">
            <Textarea label='Observación'
              style={{ height: 70 }}
              name="observacion"
              onChange={onChange}
              disabled={
                operacion === 1 || (operacion === 3 && props.presu && props.presu.reversado === 0)
                  ? false
                  : true
              }
              defaultValue={
                props.presu ? props.presu.observaciones.trim() : ""
              }
              placeholder="Describa la Observación"
              id="inputDireccion"
              ref={txtObservacion}
            />
          </fieldset>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          onClick={onChangeValidar}
          disabled={operacion === 4 ? true : false}
        >
          Aceptar
        </SuccessButton>
        <DangerButton onClick={cancelar}>Cancelar</DangerButton>
        {/*<DangerButton onClick={cancelar}>Cancelar</DangerButton>*/}
        {props.presu && props.operacion === 4 && (
          <PrimaryButton onClick={imprimirTraslados} icon="fa-print">
            Imprimir
          </PrimaryButton>
        )}
      </Modal.Footer>
      <CatalogoOrganismot
        show={mostrar3}
        onHideCancelar={handleCancelara}
        onHideAceptaOrganismo={handleAceptaOr}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};
